var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-header"},[_c('h1',[_vm._v(_vm._s(_vm.video.title))]),_c('Toggle',{staticClass:"toggle",attrs:{"options":['VirtualDirector', 'Free View'],"store":"player.viewMode","mutation":"setViewMode"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }